<template>
	<div :id="image.id" class="c-object__development__button">
		<a class="c-object__development" :href="image.url" ref="objectCard" :tabindex="linkTabindex">
			<div class="c-object__development__imagearea">
				<picture>
					<source :srcset="image.tabletImageUrl" media="(min-width:372px) and (max-width:770px)" />
					<img
						:src="image.imageUrl"
						:alt="image.text"
						:title="image.text"
					/>
				</picture>
				<div
					class="c-object__development__labelarea"
					v-if="image.labelText"
					:style="`background-color: ${image.labelColor}`"
				>
					<p class="c-object__development__labelarea--text">
						{{ image.labelText }}
					</p>
					<div class="c-object__development__labelarea--circle"></div>
				</div>
				<div
					class="c-object__development__statusarea"
					v-if="image.imageText"
				>
					<p class="c-object__development__statusarea--text">
						{{ image.imageText }}
					</p>
				</div>
			</div>

			<div class="c-object__development__textarea">
				<div>
					<h2 v-if="headingLevel === 'h2'" class="c-object__development__scroller--heading">
						{{ image.text }}
					</h2>
					<h3 v-else class="c-object__development__scroller--heading">
						{{ image.text }}
					</h3>
					<p v-if="image.subText" class="c-object__development__scroller--text2">
						{{ image.subText }}
						<span v-if="image.size">{{ image.size }}</span>
					</p>
					<p v-if="image.preamble" class="c-object__development__scroller--preamble">
						{{
							image.preamble.length > 125
							? image.preamble.substring(0, 125) + "..."
							: image.preamble
						}}
					</p>
				</div>

				<div class="c-object__development__link">
					<span class="accessible-a" :aria-label="image.text" aria-hidden="true"></span>
					<span class="t-visually-hidden">{{ image.text }}</span>
					<span>{{ readMoreLabel }}</span>
					<v-icon :name="getIcon(image.url)" size="xxs"></v-icon>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
import VIcon from "../../icon/VIcon.vue";

export default {
	components: { VIcon },
	name: "VObjectDevelopment",
	props: {
		image: {
			type: Object,
			default: {}
		},
		readMoreLabel: {
			type: String,
			default: "Läs mer"
		},
		headingLevel: {
			type: "h2" | "h3",
			default: "h2"
		}
	},
	methods: {
		isExternalUrl(url) {
			return /^(http|https|\/\/)/.test(url) && !url.includes(window.location.hostname);
		},
		getIcon(url) {
			return this.isExternalUrl(url) ? "icon-external" : "icon-chevron";
		}
	},
	data: function() {
		return {
			tabindex: 0,
			slickParentElement: null,
		}
	},
	computed: {
		linkTabindex: function() {
			if (this.slickParentElement && this.slickParentElement.getAttribute('aria-hidden') === "true") {
				return '-1';
			} else {
				return '0';
			}
		},
	},
	mounted: function() {
		this.slickParentElement = this.$refs.objectCard.closest('.c-gallery-image-scroller__item');
	}
};
</script>
